const faqData = [
    {
        "id": 1,
        "question": "How can I book an appointment with a doctor?",
        "answer": "Booking an appointment is easy! Simply visit the doctor's profile, select an available slot, and provide your details. You'll receive a confirmation email once your appointment is scheduled."
    },
    {   "id": 2,
        "question": "What should I do if I need to cancel my appointment?",
        "answer": "To cancel an appointment, log in to your account, go to your bookings, and click the \"Cancel\" button next to the appointment. Please cancel at least 24 hours in advance to avoid any cancellation fees."
    },
    {   
        "id": 3,
        "question": "Are my personal details secure when I book an appointment?",
        "answer": "Yes, your personal information is secure. We use advanced encryption and security measures to protect your data. We only share your details with the doctor for the purpose of your appointment."
    },
    {   
        "id": 4,
        "question": "How can I provide feedback or a review after my appointment?",
        "answer": "After your appointment, you'll receive an email inviting you to leave a review. You can also log in to your account, go to your past appointments, and share your feedback there. Your reviews help others in the community."
    },
    {   
        "id": 5,
        "question": "Can I change my preferred language for communication?",
        "answer": "Yes, you can change your preferred language in your account settings. We support multiple languages to ensure you have the best experience while using our platform."
    }
]

export default faqData;